(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name crewDownloads.controller:CrewDownloadsCtrl
	 * 
	 * @description
	 * 
	 */
	angular.module('crewDownloads').controller('CrewDownloadsCtrl',
			CrewDownloadsCtrl);

	function CrewDownloadsCtrl(CommonMasterData, $sce, CommonLogicService) {
		var vm = this;
		vm.ctrlName = 'CrewDownloadsCtrl';
		vm.model = {
			searchPanelToggle : true,
			searchCriteria : {
				fromDate : null,
				toDate : null,
				crewType : null,
				crewId : null,
				category : null
			},
			masterList : {
				categoryList : [],
				crewTypeList : [],
				fromDateFormatInvalid : false,
				toDateFormatInvalid : false,
				fromDateAfterToDate : false,
				isCrewNotSelected : false
			},
			initialSearchDone : false,
			reportDataURL : null,
			reportServerBaseUrl : null
		};

		// toggle search
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		// submit search
		vm.submitSearch = function(params) {
			searchCrewDownloads(params);
		};

		// on change search field
		vm.changeSearchField = function(searchParams, flag) {
			setDateValidationFlags();
			if (!vm.model.masterList.toDateFormatInvalid
					&& !vm.model.masterList.fromDateFormatInvalid) {
				if (istoDateBeforeFromDate()) {
					vm.model.masterList.fromDateAfterToDate = true;
				} else {
					vm.model.masterList.fromDateAfterToDate = false;
				}
			} else {
				vm.model.masterList.fromDateAfterToDate = false;
			} 
			if(flag == 'crewType' || flag == 'crewId'){
				if((!!vm.model.searchCriteria.crewType && !!vm.model.searchCriteria.crewType.crewTypeCode)
						|| !!vm.model.searchCriteria.crewId){
					vm.model.masterList.isCrewNotSelected = false;
				}else {
					vm.model.masterList.isCrewNotSelected = true;
				}
			}
		};

		function setDateValidationFlags() {
			// if from date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
				vm.model.masterList.fromDateFormatInvalid = true;
			} else {
				vm.model.masterList.fromDateFormatInvalid = false;
			}

			// if to date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
				vm.model.masterList.toDateFormatInvalid = true;
			} else {
				vm.model.masterList.toDateFormatInvalid = false;
			}
		}

		function isDateFormatInvalid(date) {
			if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
				return true;
			}
			return false;
		}

		// check from date and to date
		function istoDateBeforeFromDate() {
			return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
					.isBefore(
							moment(vm.model.searchCriteria.fromDate,
									"DD/MM/YYYY"));
		}
		;

		// search Crew Sales Report
		function searchCrewDownloads(param) {
			vm.model.initialSearchDone = true;
			if (isValidSearchParams(param)) {
				vm.model.searchCriteria = param;
				vm.model.searchPanelToggle = false;
				var url = CommonLogicService.getReportUrl(
						'crew_download.rptdesign', getSearchParamMap(param));
				vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
			}
		}

		// set search param map
		function getSearchParamMap(param) {
			var searchParamMap = {};
			searchParamMap["fromDate"] = param.fromDate;
			searchParamMap["toDate"] = param.toDate;
			if (!!param.crewType && !!param.crewType.crewTypeCode) {
				searchParamMap["crewType"] = param.crewType.crewTypeCode;
			}
			if (!!param.crewId) {
				searchParamMap["crewId"] = param.crewId;
			}
			if (!!param.category && !!param.category.categoryCode) {
				searchParamMap["category"] = param.category.categoryCode;
			}
			return searchParamMap;
		}

		function isValidSearchParams(params) {
			setDateValidationFlags();
			// if date invalid
			if (vm.model.masterList.toDateFormatInvalid
					|| vm.model.masterList.fromDateFormatInvalid) {
				return false;
			} else if (istoDateBeforeFromDate()) {
				vm.model.masterList.fromDateAfterToDate = true;
				return false;
			} else {
				vm.model.masterList.fromDateAfterToDate = false;
				if ((!!vm.model.searchCriteria.crewType && !!vm.model.searchCriteria.crewType.crewTypeCode)
						|| (!!vm.model.searchCriteria.crewId)) {
					vm.model.masterList.isCrewNotSelected = false;
					return true;
				} else {
					vm.model.masterList.isCrewNotSelected = true;
					return false;
				}
			}
		}

		(function() {
			// load download category list
			CommonMasterData.getDownloadCategoryList(function(categoryList) {
				vm.model.masterList.categoryList = categoryList;
			}, function(error) {
				console.log('Download Category List retrieval error!!!');
			});
			// crew type codes
			CommonMasterData.getCrewTypeList(function(crewTypeList) {
				vm.model.masterList.crewTypeList = crewTypeList;
			}, function() {
				console.log('Crew Type list retrieval error');
			});
		})();
	}
}());
